class FilterCheckboxesComponent extends HTMLElement {
  constructor() {
    super();
    this.handleToggle = this.handleToggle.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  connectedCallback() {
    this.toggleBtn = this.querySelector(".js-filter-checkboxes__toggle-btn");
    this.toggleText = this.querySelector(".js-filter-checkboxes__toggle-text");
    this.hiddenInputs = this.querySelectorAll(".filter-checkboxes__input--hidden");
    this.searchInput = this.querySelector(".js-filter-search");
    this.searchIcon = this.querySelector(".js-search-icon");
    this.searchIconSearch = this.searchIcon?.querySelector(".js-search-icon-search");
    this.searchIconClose = this.searchIcon?.querySelector(".js-search-icon-close");

    // Get stored expanded state for this filter
    const filterId = this.closest('filter-dropdown-item')?.id;
    if (filterId) {
      const isExpanded = localStorage.getItem(`filter-expanded-${filterId}`) === 'true';
      if (isExpanded && this.toggleBtn) {
        this.expandFilter();
      }

      // Restore previous search term if it exists
      if (this.searchInput) {
        const savedSearch = localStorage.getItem(`filter-search-${filterId}`);
        if (savedSearch) {
          this.searchInput.value = savedSearch;
          this.handleSearch({ target: this.searchInput }); // Trigger search with saved term
        }
      }
    }

    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle);
    }

    if (this.searchInput) {
      this.searchInput.addEventListener("input", this.handleSearch);
    }

    if (this.searchIcon) {
      this.searchIcon.addEventListener("click", () => {
        if (this.searchInput.value) {
          this.searchInput.value = "";
          this.searchInput.dispatchEvent(new Event("input"));
          this.searchIconSearch.classList.remove("hidden");
          this.searchIconClose.classList.add("hidden");
          
          // Clear saved search when clearing input
          const filterId = this.closest('filter-dropdown-item')?.id;
          if (filterId) {
            localStorage.removeItem(`filter-search-${filterId}`);
          }
        }
      });
    }
  }

  disconnectedCallback() {
    if (this.toggleBtn) {
      this.toggleBtn.removeEventListener("click", this.handleToggle);
    }
    if (this.searchInput) {
      this.searchInput.removeEventListener("input", this.handleSearch);
    }
  }

  expandFilter() {
    const visibleInputs = Array.from(
      this.querySelectorAll(".filter-checkboxes__input:not(.filter-checkboxes__input--filtered)")
    );
    
    visibleInputs.forEach((input) => {
      input.classList.remove("filter-checkboxes__input--hidden");
    });

    this.toggleText.textContent = "Weniger anzeigen";
    this.toggleBtn.setAttribute("aria-expanded", "true");
  }

  updateToggleButtonVisibility(visibleInputs) {
    if (this.toggleBtn) {
      if (visibleInputs.length <= 5) {
        this.toggleBtn.style.display = "none";
      } else {
        this.toggleBtn.style.display = "block";
        const isExpanded = this.toggleBtn.getAttribute("aria-expanded") === "true";
        visibleInputs.forEach((input, index) => {
          if (index >= 5) {
            input.classList.toggle("filter-checkboxes__input--hidden", !isExpanded);
          }
        });
      }
    }
  }

  handleToggle() {
    const isExpanded = this.toggleBtn.getAttribute("aria-expanded") === "true";
    const visibleInputs = Array.from(
      this.querySelectorAll(".filter-checkboxes__input:not(.filter-checkboxes__input--filtered)"),
    );

    visibleInputs.forEach((input, index) => {
      if (index >= 5) {
        input.classList.toggle("filter-checkboxes__input--hidden", isExpanded);
      }
    });

    this.toggleText.textContent = isExpanded ? "Alle anzeigen" : "Weniger anzeigen";
    this.toggleBtn.setAttribute("aria-expanded", !isExpanded);

    // Store expanded state
    const filterId = this.closest('filter-dropdown-item')?.id;
    if (filterId) {
      localStorage.setItem(`filter-expanded-${filterId}`, !isExpanded);
    }
  }

  handleSearch(e) {
    const searchTerm = e.target.value.toLowerCase();
    const filterInputs = this.querySelectorAll(".filter-checkboxes__input");

    filterInputs.forEach((input) => {
      const label = input.getAttribute("data-filter-label");
      const matches = label.includes(searchTerm);
      input.classList.toggle("filter-checkboxes__input--filtered", !matches);
      input.classList.toggle("filter-checkboxes__input--hidden", !matches);
    });

    if (this.searchIconSearch && this.searchIconClose) {
      this.searchIconSearch.classList.toggle("hidden", !!searchTerm);
      this.searchIconClose.classList.toggle("hidden", !searchTerm);
    }

    const visibleInputs = Array.from(filterInputs).filter(
      (input) => !input.classList.contains("filter-checkboxes__input--filtered"),
    );

    this.updateToggleButtonVisibility(visibleInputs);

    // Save search term
    const filterId = this.closest('filter-dropdown-item')?.id;
    if (filterId) {
      if (searchTerm) {
        localStorage.setItem(`filter-search-${filterId}`, searchTerm);
      } else {
        localStorage.removeItem(`filter-search-${filterId}`);
      }
    }
  }
}

if (!customElements.get("filter-checkboxes")) {
  customElements.define("filter-checkboxes", FilterCheckboxesComponent);
}
